import { useMemo } from 'react'

import { EuiAvatar } from '@equipmentshare/ds2'

import {
	TruckLineIcon,
	HomeLineIcon,
} from '@equipmentshare/ds2-icons'

import styles from './stackedAvatars.module.css'

export type ChildQuantity = {
	name: string,
	quantity?: number,
}

export type StackedAvatarsProps = {
	childQuantities: ChildQuantity[],
}

export default function StackedAvatars( { childQuantities }: StackedAvatarsProps ) {
	const items = useMemo( () => {
		const childIcons = childQuantities
			.filter( ( childQuantity ) => childQuantity.quantity )
			.map( ( childQuantity ) => ( { key: childQuantity.name, name: childQuantity.name, value: TruckLineIcon } ) )

		return [
			{ key: 'parent', name: 'Branch', value: HomeLineIcon },
			...childIcons,
		].reverse()
	}, [ childQuantities ] )

	return (
		<div
			className={styles.stackedAvatars}
		>
			{items.map( ( item ) => (
				<EuiAvatar
					className={styles.avatar}
					key={item.key}
					name={item.name}
					iconType={item.value}
					iconSize="m"
					color="plain"
				/>
			) )}
		</div>
	)
}
